/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S5_Li1Inputs */

const en_guide_large_json_files_s5_li1 = /** @type {(inputs: Guide_Large_Json_Files_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>NDJSON</strong> (Newline Delimited JSON): One JSON object per line, ideal for logs and streaming`)
};

const ko_guide_large_json_files_s5_li1 = /** @type {(inputs: Guide_Large_Json_Files_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>NDJSON</strong> (Newline Delimited JSON): 한 줄에 하나의 JSON 객체, 로그와 스트리밍에 이상적`)
};

const ja_guide_large_json_files_s5_li1 = /** @type {(inputs: Guide_Large_Json_Files_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>NDJSON</strong>（改行区切りJSON）:  1行に1つのJSONオブジェクト、ログやストリーミングに最適`)
};

/**
* | output |
* | --- |
* | "<strong>NDJSON</strong> (Newline Delimited JSON): One JSON object per line, ideal for logs and streaming" |
*
* @param {Guide_Large_Json_Files_S5_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s5_li1 = /** @type {((inputs?: Guide_Large_Json_Files_S5_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S5_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s5_li1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s5_li1(inputs)
	return ja_guide_large_json_files_s5_li1(inputs)
});